import SectionHeading from "./SectionHeading";
import { StaggerGroup, StaggerItem } from "../shared/Reveal";
import { HOW_WE_HELP } from "../../data/homeContent";

export default function HowWeHelp() {
  return (
    <section className="bg-background py-20 md:py-28 lg:py-36" data-testid="how-we-help">
      <div className="container-psv">
        <SectionHeading eyebrow={HOW_WE_HELP.eyebrow} heading={HOW_WE_HELP.heading} intro={HOW_WE_HELP.intro} />
        <StaggerGroup className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
          {HOW_WE_HELP.steps.map((step) => (
            <StaggerItem key={step.n} className="group">
              <div className="flex items-start gap-5 pb-6 border-t border-border pt-6 group-hover:border-accent transition-colors">
                <span className="font-serif text-4xl text-accent leading-none">{step.n}</span>
                <div>
                  <h3 className="font-serif text-2xl text-primary mb-2">{step.title}</h3>
                  <p className="text-[15px] text-secondary-foreground leading-relaxed">{step.text}</p>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
